import { createFileRoute, redirect } from '@tanstack/react-router'

import { LoginPage } from '@/shared/auth/components/LoginPage'
import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

interface LoginSearch {
  // Optional banner trigger — set when arriving after a successful
  // password change so we can show "password changed, sign in with the
  // new password" on the login form.
  changed?: 'password' | undefined
}

// Login page — when an already-authenticated user hits /login (e.g.
// typed URL or back button), bounce to their role's home rather than
// re-rendering the form.
export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (state.isAuthenticated) {
      throw redirect({ to: postLoginRedirect(state.user?.role_name) })
    }
  },
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    changed: search['changed'] === 'password' ? 'password' : undefined,
  }),
  component: LoginPage,
})
